// Rotating placeholder hints shown while an answer is being produced. They are
// deliberately query-agnostic: the same chat handles document extraction, KPI
// questions, follow-ups and small talk, so a hint must read sensibly for any of
// them. An animated ellipsis is appended by the renderer — no trailing
// punctuation here.
const FALLBACK_MESSAGES = [
  "Working on it",
  "Reading your message",
  "Gathering context",
  "Thinking it through",
  "Looking into it",
  "Weighing the details",
  "Checking the specifics",
  "Pulling the pieces together",
  "Putting the answer together",
  "Reviewing what I have",
];

// The renderer draws its own animated ellipsis after the hint, so a trailing
// "…", ".", "!" or "?" would double up. Strip it from override entries.
function stripTrailingPunctuation(message: string): string {
  return message.replace(/[.!?…]+$/, "").trimEnd();
}

export function getThinkingMessages(): string[] {
  const raw = process.env.REACT_APP_THINKING_MESSAGES;
  if (raw) {
    const parsed = raw
      .split("|")
      .map((m) => stripTrailingPunctuation(m.trim()))
      .filter(Boolean);
    if (parsed.length > 0) return parsed;
  }
  return FALLBACK_MESSAGES;
}

export function pickThinkingMessage(): string {
  const messages = getThinkingMessages();
  return messages[Math.floor(Math.random() * messages.length)];
}
